// src/features/sales-chess/SalesChessPageSkeleton.tsx
import React from 'react';
import { SkBox, SkText } from '../../components/SkeletonLoader/SkeletonLoader';
import styles from './SalesChessPageSkeleton.module.css';

// Number of month columns to simulate (12 months + 1 total = 13)
const MONTH_COLS = 13;
const MONTH_COL_W = 70;
const CLIENT_COL_W = 180;

const GridRowSk: React.FC = () => (
  <div className={styles.gridRow}>
    <SkText width={CLIENT_COL_W} height={13} style={{ flexShrink: 0 }} />
    {Array.from({ length: MONTH_COLS }).map((_, i) => (
      <SkText key={i} width={MONTH_COL_W} height={13} style={{ flexShrink: 0 }} />
    ))}
  </div>
);

const SalesChessPageSkeleton: React.FC = () => (
  <div className={styles.skeletonWrapper}>
    <div className={styles.gridContainer}>
      {/* Header row with month columns */}
      <div className={styles.gridHeader}>
        <SkText width={CLIENT_COL_W} height={13} style={{ flexShrink: 0 }} />
        {Array.from({ length: MONTH_COLS }).map((_, i) => (
          <SkText key={i} width={MONTH_COL_W} height={13} style={{ flexShrink: 0 }} />
        ))}
      </div>
      {/* 8 client rows */}
      {Array.from({ length: 8 }).map((_, i) => <GridRowSk key={i} />)}
    </div>
  </div>
);

export default SalesChessPageSkeleton;
